<div class="overview">
    <div class="container">
        <div class="overview-breadcrumb">
            <span>{{ breadcrumb }}</span>
        </div>
        <h1 class="overview-title">{{ title }}</h1>
    </div>

    <div class="overview-image">
        <img [src]="image" />
    </div>
</div>
